/**
 * order Item card footer - use for display information at the bottom of the item ex. quantity of history order item 
 */

import React from "react"

export default ({ item, className }) => {
    return (
        <div className={className}>
            x {item.quantity}
        </div>
    )
}